import ColorPicker from './ColorPicker';

export type { ColorPickerProps } from './interface';
export type { AggregationColor as Color } from './color';

export default ColorPicker;
